'use client'

import { useLabels } from 'labels/hooks/useLabels/useLabels'
import type { OrderLineWithFormattedPrices } from 'my-purchases/types/purchaseCommon'
import { useResponsive } from 'responsive/hooks/useResponsive/useResponsive'

import { OrderArticle } from './components/OrderArticle/OrderArticle'

import styles from './OrderArticlesListContainer.module.scss'
import texts from 'fukku/styles/texts.module.scss'

interface OrderArticlesListContainerProps {
	readonly articles: OrderLineWithFormattedPrices[]
	readonly isDisabled?: boolean
}

export function OrderArticlesListContainer({
	articles,
	isDisabled,
}: OrderArticlesListContainerProps) {
	const { t } = useLabels()
	const { isLargeOrGreater } = useResponsive()

	return (
		<div className={styles.container}>
			{isLargeOrGreater && (
				<h2 className={`${styles.title} ${texts.titleL}`}>
					{t('my_purchases.receipt.items')}
				</h2>
			)}
			<ul className={styles.list}>
				{articles.map((article) => (
					<li key={`${article.id}-${article.sizeId}`}>
						<OrderArticle article={article} isDisabled={isDisabled} />
					</li>
				))}
			</ul>
		</div>
	)
}
